// @flow

import { Map, fromJS } from 'immutable';

export const GET_PAYMENT_DETAILS = 'App/Payment/GET_PAYMENT_DETAILS';
export const GET_PAYMENT_DETAILS_SUCCESS = 'App/Payment/GET_PAYMENT_DETAILS_SUCCESS';
export const GET_PAYMENT_DETAILS_FAIL = 'App/Payment/GET_PAYMENT_DETAILS_FAIL';
export const CHECK_USER_PAYMENT = 'App/Payment/CHECK_USER_PAYMENT';
export const CHECK_USER_PAYMENT_SUCCESS = 'App/Payment/CHECK_USER_PAYMENT_SUCCESS';
export const CHECK_USER_PAYMENT_FAIL = 'App/Payment/CHECK_USER_PAYMENT_FAIL';
export const CLEAR_PAYMENT_CHECK = 'App/Payment/CLEAR_PAYMENT_CHECK';
export const SEND_PAYMENT_LINK = 'App/Payment/SEND_PAYMENT_LINK';
export const SEND_PAYMENT_LINK_SUCCESS = 'App/Payment/SEND_PAYMENT_LINK_SUCCESS';
export const SEND_PAYMENT_LINK_FAIL = 'App/Payment/SEND_PAYMENT_LINK_FAIL';
export const CLEAR_SEND_PAYMENT_LINK = 'App/Payment/CLEAR_SEND_PAYMENT_LINK';

const initialState = Map({
  getPaymentDetailsLoading: false,
  paymentDetails: Map({}),
  getPaymentDetailsFail: null,
  sendPaymentLinkLoading: false,
  sendPaymentLinkSuccess: Map({}),
  sendPaymentLinkFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_PAYMENT_DETAILS:
      return state.merge({
        getPaymentDetailsLoading: true,
        getPaymentDetailsFail: null,
      });
    case GET_PAYMENT_DETAILS_SUCCESS:
      return state.merge({
        getPaymentDetailsLoading: false,
        paymentDetails: fromJS(action.data),
        getPaymentDetailsFail: null,
      });
    case GET_PAYMENT_DETAILS_FAIL:
      return state.merge({
        getPaymentDetailsLoading: false,
        getPaymentDetailsFail: fromJS(action.data),
      });

    case SEND_PAYMENT_LINK:
      return state.merge({
        sendPaymentLinkLoading: true,
        sendPaymentLinkFail: null,
      });
    case SEND_PAYMENT_LINK_SUCCESS:
      return state.merge({
        sendPaymentLinkLoading: false,
        sendPaymentLinkSuccess: fromJS(action.data),
        sendPaymentLinkFail: null,
      });
    case SEND_PAYMENT_LINK_FAIL:
      return state.merge({
        sendPaymentLinkLoading: false,
        sendPaymentLinkFail: fromJS(action.data),
      });
    case CLEAR_SEND_PAYMENT_LINK:
      return state.merge({
        sendPaymentLinkLoading: false,
        sendPaymentLinkSuccess: Map({}),
        sendPaymentLinkFail: null,
      });
    default:
      return state;
  }
};

export const getPaymentDetails = () => (dispatch : any) =>
  dispatch({ type: GET_PAYMENT_DETAILS });

export const clearCheckPayment = () => (dispatch : any) =>
  dispatch({ type: CLEAR_PAYMENT_CHECK });

export const sendPaymentLink = (data : string) => (dispatch : any) =>
  dispatch({ type: SEND_PAYMENT_LINK, data });

export const clearSendPaymentLink = () => (dispatch : any) =>
  dispatch({ type: CLEAR_SEND_PAYMENT_LINK });
